import React from "react"
import { imageUrl } from "../../utils/path"
import ReactPlayer from 'react-player'


export const BlogpostVideo = ({data}) => {
    return <div className="video-container">
        <ReactPlayer className="video-blogpost" controls={true} url={imageUrl(data.VideoDatei.url)}/>
    </div>
    }